import { useMemo } from 'react';

const useReadUserDetails = () => {
  const userDetails = useMemo(() => {
    const userData = localStorage.getItem('user_data');
    return userData ? JSON.parse(userData) : null;
  }, []);

  return userDetails;
};

export default useReadUserDetails;
